// Base translations for the website - Slovak source texts
// These will be automatically translated to other languages via the translate-content edge function

export const baseTranslations = {
  // Navigation
  'nav.home': 'Domov',
  'nav.services': 'Služby',
  'nav.official_translations': 'Úradné preklady',
  'nav.official_translations_desc': 'Overené súdnym prekladateľom',
  'nav.legalization': 'Legalizácia dokumentov',
  'nav.legalization_desc': 'Apostille a superlegalizácia',
  'nav.pricing': 'Cenník',
  'nav.about': 'O nás',
  'nav.faq': 'FAQ',
  'nav.contact': 'Kontakt',
  'nav.calculator': 'Online kalkulácia',
  'nav.calculator_short': 'Kalkulácia',
  'nav.translations_short': 'Preklady',
  'nav.legalization_short': 'Legalizácia',
  'nav.apostila': 'Apostila',
  'nav.superlegalization': 'Superlegalizácia',
  'nav.foreign_documents': 'Zahraničné dokumenty',
  'nav.services_overview': 'Prehľad služieb',
  'nav.tagline': 'Preklady & Legalizácia',

  // Hero Section
  'hero.trust_badge': '11 rokov skúseností • 180+ Google referencií',
  'hero.title_line1': 'Úradné preklady.',
  'hero.title_line2': 'Profesionálne. Spoľahlivo.',
  'hero.subtitle': 'Rýchle a spoľahlivé služby súdnych prekladov a apostille overení pre súkromné osoby aj firmy.',
  'hero.cta_calculator': 'Vypočítať cenu online',
  'hero.cta_contact': '0907 999 909',
  'hero.badge_clients': '500+ spokojných klientov',
  'hero.badge_languages': '30+ jazykov',
  'hero.badge_express': 'Expresné dodanie',

  // Trust Section
  'trust.documents_value': '1 000+',
  'trust.documents_label': 'Preložených dokumentov',
  'trust.reviews_value': '180+',
  'trust.reviews_label': 'Google referencií',
  'trust.experience_value': '11+',
  'trust.experience_label': 'Rokov skúseností',
  'trust.complaints_value': '0',
  'trust.complaints_label': 'Reklamácií',

  // Services Section
  'services.badge': 'Naše služby',
  'services.title': 'Komplexné prekladateľské služby',
  'services.subtitle': 'Ponúkame profesionálne preklady do a z viac ako 30 jazykov. Každý preklad je spracovaný certifikovanými odborníkmi. Zároveň vybavíme jeho legalizáciu pre použitie v zahraničí.',
  'services.official_translations.title': 'Úradné preklady',
  'services.official_translations.description': 'Preklady overené súdnym prekladateľom s pečiatkou a podpisom. Platné pre úrady, súdy a iné inštitúcie.',
  'services.official_translations.feature1': 'Rodné listy',
  'services.official_translations.feature2': 'Sobášne listy',
  'services.official_translations.feature3': 'Diplomy',
  'services.official_translations.feature4': 'Výpisy z registra trestov',
  'services.official_translations.feature5': 'Zmluvy',
  'services.official_translations.feature6': 'Plnomocenstvá',
  'services.legalization.title': 'Legalizácia dokumentov',
  'services.legalization.description': 'Apostille a superlegalizácia pre použitie slovenských aj zahraničných dokumentov v zahraničí.',
  'services.legalization.feature1': 'Apostille',
  'services.legalization.feature2': 'Superlegalizácia',
  'services.legalization.feature3': 'Konzulárne overenie',
  'services.legalization.feature4': 'Poradenstvo',
  'services.learn_more': 'Zistiť viac',

  // How It Works Section
  'how_it_works.badge': 'Ako to funguje',
  'how_it_works.title': 'Tri jednoduché kroky',
  'how_it_works.subtitle': 'Celý proces od nahrania dokumentu po získanie ceny trvá len 30 sekúnd.',
  'how_it_works.step1.number': '01',
  'how_it_works.step1.title': 'Nahrajte dokument',
  'how_it_works.step1.description': 'Jednoducho nahrajte váš dokument vo formáte PDF, JPG alebo PNG.',
  'how_it_works.step2.number': '02',
  'how_it_works.step2.title': 'Získajte cenu',
  'how_it_works.step2.description': 'Okamžite vidíte presnú cenu úradného prekladu. Bez skrytých poplatkov, transparentne.',
  'how_it_works.step3.number': '03',
  'how_it_works.step3.title': 'Objednajte a vyhotovíme',
  'how_it_works.step3.description': 'Po objednávke sa náš tím ihneď pustí do práce. Preklad doručíme v dohodnutom termíne.',
  'how_it_works.cta': 'Vyskúšať teraz',
  'how_it_works.step_label': 'Krok',

  // Why Us Section
  'why_us.badge': 'Prečo my',
  'why_us.title': 'Čo nás odlišuje od konkurencie',
  'why_us.subtitle': 'Kombinujeme tradičnú kvalitu s modernou technológiou pre najlepší zážitok.',
  'why_us.unique_badge': 'Unikátne',
  'why_us.calculator.title': 'Online kalkulácia',
  'why_us.calculator.description': 'Ako jediní na trhu ponúkame okamžitú online kalkuláciu ceny. Viete presne, koľko zaplatíte, ešte pred objednávkou.',
  'why_us.ai.title': 'AI korektúra prekladov',
  'why_us.ai.description': 'Využívame umelú inteligenciu na kontrolu a korektúru prekladov pre maximálnu presnosť a konzistentnosť.',
  'why_us.fast.title': 'Rýchle dodanie',
  'why_us.fast.description': 'Expresné preklady po dohode. Štandardný termín do 5 pracovných dní podľa rozsahu.',
  'why_us.security.title': 'Šifrované dokumenty',
  'why_us.security.description': 'End-to-end šifrovanie všetkých dokumentov. Vaše súkromie a bezpečnosť sú našou prioritou.',
  'why_us.price.title': 'Transparentné ceny',
  'why_us.price.description': 'Žiadne skryté poplatky. Cena, ktorú vidíte v kalkulačke, je konečná vrátane DPH.',
  'why_us.delivery.title': 'Doručenie do celého sveta',
  'why_us.delivery.description': 'Zasielame poštou alebo DHL kamkoľvek na svete s možnosťou sledovania zásielky.',

  // References Section
  'references.badge': 'Referencie',
  'references.title': 'Dôverujú nám',
  'references.subtitle': 'Spolupracujeme s poprednými slovenskými aj medzinárodnými spoločnosťami',

  // Testimonials Section
  'testimonials.badge': 'Recenzie',
  'testimonials.title': 'Čo o nás hovoria klienti',
  'testimonials.subtitle': 'Prečítajte si referencie od našich spokojných zákazníkov.',

  // CTA Section
  'cta.title': 'Pripravení začať?',
  'cta.subtitle': 'Získajte cenovú ponuku za 30 sekúnd. Stačí nahrať dokument a my sa postaráme o zvyšok.',
  'cta.button_calculator': 'Spočítať cenu online',
  'cta.button_phone': '0907 999 909',
  'cta.footer_text': 'Bez záväzkov • Okamžitá odpoveď • Transparentné ceny',

  // Footer
  'footer.tagline': 'Preklady & Legalizácia',
  'footer.description': 'Profesionálne prekladateľské služby s online kalkuláciou ceny. Súčasť skupiny Legalizačné centrum a AKMV advokátska kancelária – komplexné riešenia pod jednou strechou.',
  'footer.partner_sites': 'Partnerské weby:',
  'footer.services_title': 'Služby',
  'footer.service_translations': 'Úradné preklady',
  'footer.service_legalization': 'Legalizácia dokumentov',
  'footer.service_apostila': 'Apostila',
  'footer.service_superlegalization': 'Superlegalizácia',
  'footer.service_foreign_documents': 'Zahraničné dokumenty',
  'footer.service_calculator': 'Online kalkulácia',
  'footer.company_title': 'Spoločnosť',
  'footer.company_about': 'O nás',
  'footer.company_pricing': 'Cenník',
  'footer.company_faq': 'FAQ',
  'footer.company_contact': 'Kontakt',
  'footer.contact_title': 'Kontakt',
  'footer.terms': 'Obchodné podmienky',
  'footer.privacy': 'Ochrana súkromia',
  'footer.copyright': 'Prelozim.sk | Legalizačné centrum Bratislava',

  // Pricing Page
  'pricing.badge': 'Cenník služieb',
  'pricing.title': 'Transparentné ceny bez skrytých poplatkov',
  'pricing.subtitle': 'Naše ceny sú uvedené za normostranu (1800 znakov vrátane medzier). Pre presnú kalkuláciu použite náš online kalkulátor.',
  'pricing.cta': 'Vypočítať presnú cenu',
  'pricing.languages_title': 'Úradné preklady podľa jazykov',
  'pricing.language': 'Jazyk',
  'pricing.price_per_page': 'Cena / normostrana',
  'pricing.languages_note': 'Ceny prekladov sú uvedené bez DPH. Pre iné jazyky nás kontaktujte pre individuálnu cenovú ponuku.',
  'pricing.legalization_title': 'Legalizácia dokumentov',
  'pricing.apostille_by_type': 'Apostille podľa typu dokumentu',
  'pricing.document_type': 'Typ dokumentu',
  'pricing.price': 'Cena',
  'pricing.legalization_note': 'Ceny legalizácie sú uvedené vrátane DPH.',
  'pricing.extras_title': 'Doplnkové služby',
  'pricing.delivery_title': 'Doručenie',
  'pricing.included_title': 'Čo je zahrnuté v cene',
  'pricing.included_1': 'Preklad certifikovaným súdnym prekladateľom',
  'pricing.included_2': 'Úradné overenie s pečiatkou a podpisom',
  'pricing.included_3': 'Kontrola a korektúra textu',
  'pricing.included_4': 'Digitálna kópia prekladu',
  'pricing.included_5': 'Archivácia dokumentov (GDPR)',
  'pricing.included_6': 'Zákaznícka podpora',
  'pricing.loading': 'Načítavam...',

  // Document types
  'document_types.74522e61-7c03-4c9f-85d8-be889367327e': 'Rodný list',
  'document_types.a61069da-9aea-4004-b7b1-ec44eecad871': 'Sobášny list',
  'document_types.db105334-161d-47f5-a5f1-a54ef013bb46': 'Úmrtný list',
  'document_types.26d06158-9bbe-49c4-af5b-a900cec17734': 'Rozvodový rozsudok - elektronická verzia',
  'document_types.3ce82d6d-c033-43f6-a29f-39fc8e12f7cf': 'Rozvodový rozsudok - papierová verzia',
  'document_types.58b07b4d-f034-4b98-a340-0516b5934801': 'Cestovný pas',
  'document_types.06b4df58-d95b-48ce-927b-ea7241cbfa69': 'Občiansky preukaz',
  'document_types.651b9398-57f9-4964-b366-e9d70c1bc09d': 'Technický preukaz',
  'document_types.9c17039b-9f9c-4502-8673-fbc5f831621e': 'Potvrdenie o pobyte cudzinca',
  'document_types.50318d4e-cccd-4247-ad31-53bdd2d03540': 'Doklady o vzdelaní - iba apostila',
  'document_types.f02c2c54-22cd-4ceb-94fa-5f7a2088075c': 'Doklady o vzdelaní - apostila + overená kópia',
  'document_types.4a64fb66-777d-43c0-9f34-4eed0a99d8da': 'Výpis z OR',
  'document_types.437800c0-7804-4fe6-88da-64636962382f': 'Notárske dokumenty (plná moc, čestné prehlásenia, zmluvy a iné)',
  'document_types.4473caec-ee12-48ff-a28f-3e035ae6d05b': 'Potvrdenie o daňovej rezidencii',
  'document_types.31ba1ed1-cadd-4425-b643-ab5953ab345c': 'Apostila prekladu',

  // FAQ Page
  'faq.badge': 'Časté otázky',
  'faq.title': 'Odpovede na vaše otázky',
  'faq.subtitle': 'Nenašli ste odpoveď? Kontaktujte nás a radi vám pomôžeme.',
  'faq.more_questions': 'Máte ďalšie otázky?',
  'faq.more_questions_text': 'Neváhajte nás kontaktovať. Radi vám pomôžeme s čímkoľvek.',
  'faq.start_calculator': 'Spustiť kalkulátor',
  'faq.contact_us': 'Kontaktovať nás',
  'faq.category_translations': 'Preklady',
  'faq.category_processing': 'Doba spracovania',
  'faq.category_security': 'Bezpečnosť a GDPR',
  'faq.category_legalization': 'Legalizácia',
  'faq.category_payments': 'Platby a doručenie',

  // Contact Page
  'contact.badge': 'Kontaktujte nás',
  'contact.title': 'Sme tu pre vás',
  'contact.subtitle': 'Máte otázku alebo potrebujete pomoc? Neváhajte nás kontaktovať. Odpovieme vám do 24 hodín.',
  'contact.info_title': 'Kontaktné údaje',
  'contact.email_label': 'E-mail',
  'contact.mobile_label': 'Mobil',
  'contact.phone_label': 'Pevná linka',
  'contact.company_label': 'Spoločnosť',
  'contact.address_label': 'Adresa',
  'contact.hours_label': 'Pracovná doba',
  'contact.need_translation': 'Potrebujete preklad?',
  'contact.get_quote': 'Získajte okamžitú cenovú kalkuláciu online.',
  'contact.form_title': 'Napíšte nám',
  'contact.form_name': 'Meno a priezvisko',
  'contact.form_phone': 'Telefón',
  'contact.form_email': 'E-mail',
  'contact.form_message': 'Správa',
  'contact.form_attachments': 'Prílohy (voliteľné)',
  'contact.form_attachments_help': 'Kliknite pre nahratie súborov',
  'contact.form_attachments_formats': 'PDF, obrázky, Word (max 15 MB)',
  'contact.form_submit': 'Odoslať správu',
  'contact.form_submitting': 'Odosielam...',
  'contact.form_success': 'Správa bola odoslaná! Ozveme sa vám čo najskôr.',
  'contact.form_error': 'Nepodarilo sa odoslať správu. Skúste to prosím znova.',
  'contact.form_privacy': 'Odoslaním formulára súhlasíte so spracovaním osobných údajov',
  'contact.map_title': 'Kde nás nájdete',

  // About Page
  'about.badge': 'O nás',
  'about.meta_title': 'O nás | Prelozim.sk – Profesionálne preklady od roku 2013',
  'about.meta_description': '11 rokov skúseností s úradnými prekladmi. Súčasť Legalizačného centra Bratislava a AKMV advokátskej kancelárie. 180+ Google referencií, 0 reklamácií.',
  'about.title': 'Profesionálne preklady s ľudským prístupom',
  'about.subtitle': 'Sme tím skúsených súdnych prekladateľov, ktorí kombinujú tradičné remeslo s modernými technológiami.',
  'about.office_alt': 'Sídlo spoločnosti Prelozim.sk v Bratislave - moderná budova na Pluhovej ulici',
  'about.office_title': 'Naša kancelária',
  'about.office_text1': 'Prelozim.sk je súčasťou Legalizačného centra Bratislava a AKMV advokátskej kancelárie – všetky tri organizácie sídlia na rovnakej adrese, čo nám umožňuje ponúknuť komplexné riešenia pod jednou strechou.',
  'about.office_text2': 'Za 11 rokov pôsobenia sme vybavili tisíce prekladov a legalizácií pre súdy, úrady, univerzity a medzinárodné spoločnosti. Máme 180+ pozitívnych hodnotení na Google a hrdíme sa nulovým počtom reklamácií.',
  'about.office_text3': 'Vďaka nášmu online kalkulátoru viete okamžite, koľko váš preklad bude stáť a kedy ho budete mať k dispozícii. Žiadne skryté poplatky, žiadne čakanie na cenovú ponuku.',
  'about.leadership_title': 'Vedenie spoločnosti',
  'about.leadership_subtitle': 'Za úspechom Prelozim.sk stoja skúsení profesionáli s vášňou pre kvalitu a precíznosť.',
  'about.founder_role': 'Konateľ',
  'about.founder1_desc': 'Zakladateľ spoločnosti s viac ako 11-ročnými skúsenosťami v oblasti prekladateľstva a legalizácie dokumentov.',
  'about.founder2_desc': 'Právnička s rozsiahlymi skúsenosťami v medzinárodnom práve a legalizácii dokumentov pre zahraničné použitie.',
  'about.team_title': 'Náš tím',
  'about.team_subtitle': 'Profesionálny tím asistentov a spolupracovníkov, ktorí zabezpečujú plynulý chod každej objednávky.',
  'about.translators_badge': 'Naši prekladatelia',
  'about.translators_title': 'Súdni prekladatelia',
  'about.translators_subtitle': 'Spolupracujeme so sieťou certifikovaných súdnych prekladateľov, ktorí zabezpečujú úradné preklady vo viac ako 30 jazykoch.',
  'about.career_badge': 'Kariéra',
  'about.career_title': 'Ste súdny prekladateľ? Pridajte sa k nám!',
  'about.career_desc': 'Hľadáme skúsených súdnych prekladateľov pre všetky jazykové kombinácie. Ponúkame pravidelné zákazky, férové podmienky spolupráce a možnosť byť súčasťou dynamického tímu.',
  'about.career_benefit1': 'Pravidelné zákazky z rôznych oblastí',
  'about.career_benefit2': 'Férové podmienky a promptná platba',
  'about.career_benefit3': 'Podpora a komunikácia v slovenčine',
  'about.career_benefit4': 'Možnosť práce na diaľku',
  'about.contact_us': 'Kontaktujte nás',
  'about.hiring_title': 'Hľadáme',
  'about.hiring_subtitle': 'prekladateľov',
  'about.hiring_desc': 'Kontaktujte nás pre spoluprácu na prekladoch vo všetkých jazykových kombináciách.',
  'about.tech_badge': 'Technológie',
  'about.tech_title': 'Moderné technológie pre lepší servis',
  'about.tech_subtitle': 'Investujeme do najmodernejších technológií, aby sme vám poskytli rýchlejší, bezpečnejší a pohodlnejší služby.',
  'about.tech1_title': 'AI korektúra prekladov',
  'about.tech1_desc': 'Využívame umelú inteligenciu na kontrolu a korektúru prekladov pre maximálnu presnosť.',
  'about.tech2_title': 'Automatické notifikácie',
  'about.tech2_desc': 'Sledovanie stavu objednávky v reálnom čase s emailovými notifikáciami pri každej zmene.',
  'about.tech3_title': 'Digitálne skenovanie',
  'about.tech3_desc': 'Profesionálne skenovanie dokumentov s vysokým rozlíšením pre zachovanie všetkých detailov.',
  'about.tech4_title': 'Bezpečná databáza',
  'about.tech4_desc': 'Centralizované ukladanie objednávok s kompletnou históriou a prístupom k dokumentom.',
  'about.tech5_title': 'Medzinárodné doručenie',
  'about.tech5_desc': 'Zasielame preklady do celého sveta – poštou alebo expresne cez DHL s možnosťou sledovania.',
  'about.tech6_title': 'Sledovanie zásielok',
  'about.tech6_desc': 'Real-time tracking zásielok s automatickými upozorneniami o stave doručenia.',
  'about.tech7_title': 'Šifrovanie dokumentov',
  'about.tech7_desc': 'End-to-end šifrovanie všetkých dokumentov počas prenosu aj uloženia na serveroch.',
  'about.tech8_title': 'Moderná infraštruktúra',
  'about.tech8_desc': 'Cloudová platforma s automatickými zálohami a vysokou dostupnosťou systému 24/7.',
  'about.values_title': 'Naše hodnoty',
  'about.value1_title': 'Certifikovaní odborníci',
  'about.value1_desc': 'Všetky preklady vykonávajú súdni prekladatelia s dlhoročnými skúsenosťami a potrebnými certifikátmi.',
  'about.value2_title': 'Rýchlosť a spoľahlivosť',
  'about.value2_desc': 'Dodržiavame dohodnuté termíny. Expresné preklady sú možné do 24 hodín.',
  'about.value3_title': 'Individuálny prístup',
  'about.value3_desc': 'Každá objednávka je jedinečná. Prispôsobíme sa vašim potrebám a požiadavkám.',
  'about.value4_title': 'Bezpečnosť a dôvera',
  'about.value4_desc': 'Vaše dokumenty sú v bezpečí. Dodržiavame prísne štandardy ochrany údajov.',
  'about.gdpr_title': 'Bezpečnosť vašich dokumentov',
  'about.gdpr_subtitle': 'Vaše súkromie a bezpečnosť dokumentov berieme vážne. Dodržiavame všetky požiadavky GDPR a využívame najmodernejšie bezpečnostné technológie.',
  'about.gdpr1_title': 'Šifrovaný prenos',
  'about.gdpr1_desc': 'Všetky dokumenty sú prenášané cez zabezpečené šifrované spojenie (TLS 1.3).',
  'about.gdpr2_title': 'Bezpečné úložisko',
  'about.gdpr2_desc': 'Dokumenty sú uložené na zabezpečených serveroch s prístupom len pre oprávnené osoby.',
  'about.gdpr3_title': 'Automatické mazanie',
  'about.gdpr3_desc': 'Po dokončení zákazky sú všetky dokumenty bezpečne vymazané do 30 dní.',
  'about.privacy_link': 'Prečítať celé zásady ochrany údajov',
  'about.cta_title': 'Pripravení začať?',
  'about.cta_subtitle': 'Získajte okamžitú cenovú kalkuláciu pre váš úradný preklad.',
  'about.cta_button': 'Spustiť kalkulátor',

  // Official Translations Page
  'official.badge': 'Naše služby',
  'official.title': 'Úradné preklady',
  'official.subtitle': 'Profesionálne preklady overené súdnym prekladateľom s pečiatkou a podpisom. Platné pre všetky úrady, súdy a inštitúcie.',
  'official.cta': 'Vypočítať cenu prekladu',
  'official.feature1_title': 'Úradné overenie',
  'official.feature1_desc': 'Každý preklad je opatrený pečiatkou a podpisom súdneho prekladateľa.',
  'official.feature2_title': 'Expresné spracovanie',
  'official.feature2_desc': 'Možnosť expresného spracovania za príplatok.',
  'official.feature3_title': 'Právna platnosť',
  'official.feature3_desc': 'Preklady sú platné pre všetky úrady, súdy a inštitúcie v SR aj zahraničí.',
  'official.feature4_title': 'Široký rozsah dokumentov',
  'official.feature4_desc': 'Prekladáme všetky typy úradných dokumentov a listín.',
  'official.documents_title': 'Aké dokumenty prekladáme?',
  'official.documents_note': 'A mnohé ďalšie... Ak si nie ste istí, kontaktujte nás.',
  'official.process_title': 'Ako to funguje?',
  'official.process_step1': 'Nahrajte dokument',
  'official.process_step1_desc': 'Nahrajte sken alebo fotografiu dokumentu cez náš online kalkulátor.',
  'official.process_step2': 'Získajte cenu',
  'official.process_step2_desc': 'Okamžite uvidíte presnú cenu a termín dodania.',
  'official.process_step3': 'Objednajte',
  'official.process_step3_desc': 'Vyplňte kontaktné údaje a potvrďte objednávku.',
  'official.process_step4': 'Prevezmite preklad',
  'official.process_step4_desc': 'Preklad vám doručíme elektronicky alebo poštou.',
  'official.cta_title': 'Potrebujete úradný preklad?',
  'official.cta_text': 'Získajte okamžitú cenovú kalkuláciu. Stačí nahrať dokument a my vám vypočítame presnú cenu a termín dodania.',
  'official.cta_button': 'Spustiť kalkulátor',

  // Legalization Page
  'legalization.badge': 'Naše služby',
  'legalization.title': 'Legalizácia dokumentov',
  'legalization.subtitle': 'Apostille a superlegalizácia pre použitie vašich dokumentov v zahraničí. Kompletný servis od A po Z.',
  'legalization.cta': 'Konzultácia zadarmo',
  'legalization.what_is_title': 'Čo je legalizácia dokumentov?',
  'legalization.what_is_text1': 'Legalizácia je proces overenia pravosti verejnej listiny pre jej použitie v zahraničí. Zabezpečuje, že dokument vydaný v jednej krajine bude uznaný v inej krajine.',
  'legalization.what_is_text2': 'Typ legalizácie závisí od cieľovej krajiny - pre signatárske krajiny Haagskej dohody postačuje Apostille, pre ostatné krajiny je potrebná superlegalizácia.',
  'legalization.services_title': 'Naše služby legalizácie',
  'legalization.apostille_title': 'Apostille',
  'legalization.apostille_price': 'od 120 €',
  'legalization.apostille_desc': 'Pre krajiny Haagskej dohody',
  'legalization.apostille_detail1': 'Overenie na príslušnom krajskom súde',
  'legalization.apostille_detail2': 'Platné vo všetkých signatárskych krajinách',
  'legalization.apostille_detail3': 'Doba spracovania: od 1 pracovného dňa podľa typu dokumentu',
  'legalization.apostille_detail4': 'Kompletné vybavenie za vás',
  'legalization.superlegalization_title': 'Superlegalizácia',
  'legalization.superlegalization_price': 'od 500 €',
  'legalization.superlegalization_desc': 'Pre krajiny mimo Haagskej dohody (vrátane konzulárneho overenia)',
  'legalization.superlegalization_detail1': 'Overenie na MZV SR',
  'legalization.superlegalization_detail2': 'Následné konzulárne overenie na veľvyslanectve',
  'legalization.superlegalization_detail3': 'Doba spracovania: 10-14 pracovných dní',
  'legalization.superlegalization_detail4': 'Poradenstvo pri výbere správneho postupu',
  'legalization.hague_title': 'Krajiny Haagskej dohody (Apostille)',
  'legalization.hague_text': 'Pre tieto krajiny postačuje jednoduchšia forma overenia - Apostille:',
  'legalization.hague_more': '+ 100 ďalších krajín',
  'legalization.combined_title': 'Preklad + Legalizácia',
  'legalization.combined_text': 'Potrebujete dokument preložiť aj legalizovať? Ponúkame výhodnú kombinovanú službu, kde sa o všetko postaráme za vás - od prekladu cez úradné overenie až po legalizáciu.',
  'legalization.combined_cta': 'Požiadať o cenovú ponuku',
  'legalization.cta_title': 'Nie ste si istí, čo potrebujete?',
  'legalization.cta_text': 'Kontaktujte nás a radi vám poradíme, aký typ legalizácie je pre vašu situáciu najvhodnejší.',
  'legalization.cta_calculator': 'Kalkulátor prekladov',
  'legalization.cta_contact': 'Kontaktovať nás',

  // Terms Page
  'terms.badge': 'Právne informácie',
  'terms.title': 'Obchodné podmienky',
  'terms.subtitle': 'Všeobecné obchodné podmienky pre poskytovanie prekladateľských služieb.',
  'terms.last_updated': 'Posledná aktualizácia',
  'terms.provider_title': 'Kontaktné údaje poskytovateľa',

  // Common
  'common.loading': 'Načítavam...',
  'common.error': 'Nastala chyba',
  'common.success': 'Úspešne odoslané',
  'common.back': 'Späť',
  'common.next': 'Ďalej',
  'common.submit': 'Odoslať',
  'common.cancel': 'Zrušiť',
  'common.save': 'Uložiť',
  'common.delete': 'Zmazať',
  'common.edit': 'Upraviť',
  'common.close': 'Zavrieť',
  'common.yes': 'Áno',
  'common.no': 'Nie',
  'common.free': 'zadarmo',

  // FAQ Page - Questions and Answers
  'faq.q1': 'Čo je úradný preklad a kedy ho potrebujem?',
  'faq.a1': 'Úradný (súdny) preklad je preklad overený súdnym prekladateľom s pečiatkou a podpisom. Potrebujete ho pre úrady, súdy, univerzity a iné inštitúcie, ktoré vyžadujú oficiálne overený dokument. Typické príklady sú rodné listy, sobášne listy, diplomy, vysvedčenia, zmluvy a výpisy z registra trestov.',
  'faq.q2': 'Ako dlho trvá vyhotovenie úradného prekladu?',
  'faq.a2': 'Štandardná doba spracovania je do 5 pracovných dní v závislosti od rozsahu dokumentu. Ponúkame aj expresné spracovanie do 48 hodín po dohode za príplatok 30% (dostupné pre vybrané jazyky ako angličtina a španielčina). Presný termín dodania vám oznámime po prijatí objednávky.',
  'faq.q3': 'Aké dokumenty môžem nahrať?',
  'faq.a3': 'Prijímame dokumenty vo formáte PDF a bežné obrazové formáty (JPG, PNG). Maximálna veľkosť súboru je 15 MB. Ak máte dokument v inom formáte, kontaktujte nás a nájdeme riešenie.',
  'faq.q4': 'Je potrebné dodať originál dokumentu?',
  'faq.a4': 'Áno, väčšinou sa vyžaduje viazať preklad s originálom dokumentu. Je to však možné aj s obyčajnou kópiou, úradne overenou kópiou alebo so skenom.',
  'faq.category_time': 'Doba spracovania',
  'faq.q5': 'Ako dlho trvá apostille?',
  'faq.a5': 'Doba spracovania apostille je od 1 pracovného dňa v závislosti od typu dokumentu. Ide o komplexný proces, ktorý môže ovplyvniť celkový čas. Presný termín vám oznámime po konzultácii.',
  'faq.q6': 'Ako dlho trvá superlegalizácia?',
  'faq.a6': 'Superlegalizácia je komplexný proces, ktorý trvá spravidla od 30 pracovných dní.',
  'faq.q7': 'Je možné expresné spracovanie?',
  'faq.a7': 'Áno, pre preklady ponúkame expresné spracovanie do 48 hodín po dohode za príplatok 30%. Táto možnosť je dostupná pre vybrané jazyky (angličtina, španielčina). Pre legalizáciu závisí rýchlosť spracovania od úradov a veľvyslanectiev.',
  'faq.q8': 'Kedy dostanem hotový preklad?',
  'faq.a8': 'Po prevzatí zákazky vystavíme faktúru. Po jej úhrade na veci začíname pracovať. Štandardne je to do 5 pracovných dní. Elektronickú kópiu (sken s pečiatkou) dostanete emailom, originál poštou alebo osobným odberom.',
  'faq.q9': 'Ako sú moje dokumenty chránené?',
  'faq.a9': 'Bezpečnosť vašich dokumentov je naša priorita. Všetky dokumenty sú prenášané cez šifrované spojenie (TLS 1.3) a uložené na zabezpečených cloudových serveroch s obmedzeným prístupom. Dokumenty uchovávame neobmedzene, vďaka čomu nás môžete kedykoľvek kontaktovať a máme všetko k dispozícii. Na požiadanie dokumenty po vykonaní prekladu vymažeme.',
  'faq.q10': 'Kto má prístup k mojim dokumentom?',
  'faq.a10': 'K vašim dokumentom má prístup len priradený súdny prekladateľ a v prípade potreby náš zákaznícky servis. Dokumenty nikdy nezdieľame s tretími stranami a nepredávame údaje na marketingové účely.',
  'faq.q11': 'Môžem požiadať o vymazanie svojich údajov?',
  'faq.a11': 'Áno, máte právo kedykoľvek požiadať o vymazanie všetkých svojich údajov vrátane dokumentov. Kontaktujte nás na office@legalizacnecentrum.sk a vaše údaje budú vymazané.',
  'faq.q12': 'Čo je Apostille?',
  'faq.a12': 'Apostille je forma medzinárodného overenia dokumentu podľa Haagskej dohody. Umožňuje použitie verejných listín v krajinách, ktoré sú signatármi tejto dohody, bez potreby ďalšieho overenia.',
  'faq.q13': 'Kedy potrebujem superlegalizáciu?',
  'faq.a13': 'Superlegalizáciu potrebujete pre krajiny, ktoré nie sú signatármi Haagskej dohody. Ide o komplexný proces overenia dokumentov.',
  'faq.q14': 'Môžete zabezpečiť celý proces legalizácie?',
  'faq.a14': 'Áno, ponúkame kompletnú službu legalizácie vrátane Apostille aj superlegalizácie. Postaráme sa o všetky potrebné úkony, návštevy úradov a doručenie finálneho dokumentu k vám.',
  'faq.q15': 'Riešite aj legalizáciu zahraničných dokumentov?',
  'faq.a15': 'Áno, zabezpečujeme legalizáciu slovenských aj zahraničných dokumentov. Pri zahraničných dokumentoch vám poradíme s postupom overenia v krajine pôvodu a následným použitím na Slovensku.',
  'faq.category_payment': 'Platby a doručenie',
  'faq.q16': 'Aké platobné metódy akceptujete?',
  'faq.a16': 'Vystavíme faktúru na úhradu bankovým prevodom alebo je možná platba v hotovosti u nás v kancelárii.',
  'faq.q17': 'Ako mi bude preklad doručený?',
  'faq.a17': 'Ponúkame elektronické doručenie (PDF so skenom originálu s pečiatkou), osobný odber v Bratislave, alebo poštové doručenie na adresu v SR aj do zahraničia. Poštovné v rámci SR je v cene. Pre rýchle doručenie ponúkame DHL kuriéra na Slovensko aj celosvetovo. Spôsob doručenia si zvolíte pri objednávke.',
  'faq.q18': 'Čo ak budem s prekladom nespokojný?',
  'faq.a18': 'V prípade akýchkoľvek nezrovnalostí alebo chýb v preklade vykonáme opravu bezplatne. Ak by preklad nespĺňal vaše požiadavky, máte možnosť reklamácie do 14 dní od doručenia.',
  'faq.meta_title': 'Časté otázky o úradných prekladoch | Prelozim.sk',
  'faq.meta_description': 'Odpovede na najčastejšie otázky o úradných prekladoch, apostille, superlegalizácii. Čo je úradný preklad, ako dlho trvá, aké sú ceny.',

  // Pricing Page - Extras
  'pricing.extra_express': 'Expresné spracovanie (do 48h, po dohode)',
  'pricing.extra_express_note': 'Dostupné pre vybrané jazyky (angličtina, španielčina)',
  'pricing.extra_notary': 'Notárske overenie',
  'pricing.superlegalization': 'Superlegalizácia',
  'pricing.from': 'od',
  'pricing.meta_title': 'Cenník úradných prekladov | Prelozim.sk',
  'pricing.meta_description': 'Transparentný cenník úradných prekladov od 30€ za normostranu. Legalizácia dokumentov, apostille. Bez skrytých poplatkov.',

  // Contact Page - Additional
  'contact.hours_value': 'Po - Pi: 9:00 - 17:00',
  'contact.form_name_placeholder': 'Ján Novák',
  'contact.form_email_placeholder': 'vas@email.sk',
  'contact.form_message_placeholder': 'Popíšte vašu požiadavku...',
  'contact.max_size_error': 'Maximálna veľkosť príloh je 15 MB',
  'contact.meta_title': 'Kontakt | Prelozim.sk – Legalizačné centrum Bratislava',
  'contact.meta_description': 'Kontaktujte nás: office@legalizacnecentrum.sk, 0907 999 909. Adresa: Pluhová 17, 831 03 Bratislava. Po-Pia 9:00-17:00.',
  'contact.schema_description': 'Profesionálne úradné preklady a legalizácia dokumentov',

  // Legalization Page - Additional
  'legalization.superlegalization': 'Superlegalizácia',
  'legalization.super_detail1': 'Overenie na MZV SR',
  'legalization.super_detail2': 'Následné konzulárne overenie na veľvyslanectve',
  'legalization.super_detail3': 'Doba spracovania: 10-14 pracovných dní',
  'legalization.super_detail4': 'Poradenstvo pri výbere správneho postupu',
  'legalization.hague_desc': 'Pre tieto krajiny postačuje jednoduchšia forma overenia - Apostille:',
  'legalization.more_countries': '+ 100 ďalších krajín',
  'legalization.combined_desc': 'Potrebujete dokument preložiť aj legalizovať? Ponúkame výhodnú kombinovanú službu, kde sa o všetko postaráme za vás - od prekladu cez úradné overenie až po legalizáciu.',
  'legalization.request_quote': 'Požiadať o cenovú ponuku',
  'legalization.not_sure_title': 'Nie ste si istí, čo potrebujete?',
  'legalization.not_sure_desc': 'Kontaktujte nás a radi vám poradíme, aký typ legalizácie je pre vašu situáciu najvhodnejší.',
  'legalization.calculator_cta': 'Kalkulátor prekladov',
  'legalization.contact_cta': 'Kontaktovať nás',
  'legalization.free_consultation': 'Konzultácia zadarmo',
  'legalization.meta_title': 'Apostille a legalizácia dokumentov | Prelozim.sk',
  'legalization.meta_description': 'Apostille od 120€, superlegalizácia od 500€. Legalizácia dokumentov pre zahraničie. Vybavíme za vás na všetkých úradoch. Bratislava.',

  // Official Translations Page - Additional
  'translations.badge': 'Naše služby',
  'translations.title': 'Úradné preklady',
  'translations.subtitle': 'Profesionálne preklady overené súdnym prekladateľom s pečiatkou a podpisom. Platné pre všetky úrady, súdy a inštitúcie.',
  'translations.calculate_cta': 'Vypočítať cenu prekladu',
  'translations.feature1_title': 'Úradné overenie',
  'translations.feature1_desc': 'Každý preklad je opatrený pečiatkou a podpisom súdneho prekladateľa.',
  'translations.feature2_title': 'Expresné spracovanie',
  'translations.feature2_desc': 'Možnosť expresného spracovania za príplatok.',
  'translations.feature3_title': 'Právna platnosť',
  'translations.feature3_desc': 'Preklady sú platné pre všetky úrady, súdy a inštitúcie v SR aj zahraničí.',
  'translations.feature4_title': 'Široký rozsah dokumentov',
  'translations.feature4_desc': 'Prekladáme všetky typy úradných dokumentov a listín.',
  'translations.doc1': 'Rodné listy',
  'translations.doc2': 'Sobášne listy',
  'translations.doc3': 'Úmrtné listy',
  'translations.doc4': 'Vysvedčenia a diplomy',
  'translations.doc5': 'Výpisy z registra trestov',
  'translations.doc6': 'Občianske preukazy a pasy',
  'translations.doc7': 'Vodičské preukazy',
  'translations.doc8': 'Zmluvy a notárske zápisnice',
  'translations.doc9': 'Lekárske správy',
  'translations.doc10': 'Súdne rozhodnutia',
  'translations.doc11': 'Firemné dokumenty',
  'translations.doc12': 'Technické dokumenty',
  'translations.documents_title': 'Aké dokumenty prekladáme?',
  'translations.documents_more': 'A mnohé ďalšie... Ak si nie ste istí, kontaktujte nás.',
  'translations.how_it_works': 'Ako to funguje?',
  'translations.step1_title': 'Nahrajte dokument',
  'translations.step1_desc': 'Nahrajte sken alebo fotografiu dokumentu cez náš online kalkulátor.',
  'translations.step2_title': 'Získajte cenu',
  'translations.step2_desc': 'Okamžite uvidíte presnú cenu a termín dodania.',
  'translations.step3_title': 'Objednajte',
  'translations.step3_desc': 'Vyplňte kontaktné údaje a potvrďte objednávku.',
  'translations.step4_title': 'Prevezmite preklad',
  'translations.step4_desc': 'Preklad vám doručíme elektronicky alebo poštou.',
  'translations.cta_title': 'Potrebujete úradný preklad?',
  'translations.cta_desc': 'Získajte okamžitú cenovú kalkuláciu. Stačí nahrať dokument a my vám vypočítame presnú cenu a termín dodania.',
  'translations.start_calculator': 'Spustiť kalkulátor',
  'translations.meta_title': 'Úradné preklady od 30€ | Prelozim.sk',
  'translations.meta_description': 'Profesionálne úradné preklady overené súdnym prekladateľom. Rodné listy, diplomy, zmluvy, výpisy. Expresné dodanie do 24h. Online kalkulácia.',

  // Countries
  'countries.austria': 'Rakúsko',
  'countries.germany': 'Nemecko',
  'countries.france': 'Francúzsko',
  'countries.italy': 'Taliansko',
  'countries.spain': 'Španielsko',
  'countries.netherlands': 'Holandsko',
  'countries.belgium': 'Belgicko',
  'countries.switzerland': 'Švajčiarsko',
  'countries.uk': 'Veľká Británia',
  'countries.usa': 'USA',
  'countries.canada': 'Kanada',
  'countries.australia': 'Austrália',
  'countries.japan': 'Japonsko',
  'countries.poland': 'Poľsko',
  'countries.czech': 'Česko',
  'countries.hungary': 'Maďarsko',

  // Languages
  'lang.sk': 'Slovenčina',
  'lang.en': 'Angličtina',
  'lang.de': 'Nemčina',
  'lang.fr': 'Francúzština',
  'lang.it': 'Taliančina',
  'lang.es': 'Španielčina',
  'lang.pl': 'Poľština',
  'lang.uk': 'Ukrajinčina',
  'lang.ru': 'Ruština',
  'lang.hu': 'Maďarčina',
  'lang.cs': 'Čeština',

  // Delivery
  'delivery.personal': 'Osobný odber',
  'delivery.personal_desc': 'Bezplatne na adrese: Pluhová 17, Bratislava',
  'delivery.post_sk_free': 'Poštou na Slovensko v cene',
  'delivery.post_sk_free_desc': 'Doručenie Slovenskou poštou je v cene služby',
  'delivery.post_abroad': 'Poštou do zahraničia',
  'delivery.post_abroad_desc': 'Medzinárodné poštové doručenie',
  'delivery.dhl_sk': 'DHL na Slovensko',
  'delivery.dhl_sk_desc': 'Kuriérske doručenie (cena bez DPH)',
  'delivery.dhl_abroad': 'DHL do zahraničia',
  'delivery.dhl_abroad_desc': 'Nacenenie individuálne',

  // Calculator Page
  'calculator.meta_title': 'Online kalkulátor ceny prekladu | Prelozim.sk',
  'calculator.meta_description': 'Vypočítajte si cenu úradného prekladu online. Nahrajte dokument a okamžite zistíte presnú cenu. Bez skrytých poplatkov.',
  
  // Step Upload
  'calculator.upload_title': 'Nahrajte dokumenty',
  'calculator.upload_subtitle': 'Zvoľte cieľové jazyky pre vaše úradné preklady.',
  'calculator.upload_add': 'Pridať dokumenty',
  'calculator.upload_formats': 'PDF alebo obrázky (max 15MB)',
  'calculator.upload_gdpr': 'Šifrované a chránené podľa GDPR',
  'calculator.upload_camera': 'Odfotiť dokument',
  'calculator.calculate_price': 'Vypočítať cenu',
  'calculator.analyzing': 'Analyzujem...',
  'calculator.analysis_failed': 'Analýza zlyhala.',
  'calculator.select_language': 'Vyberte cieľový jazyk',
  'calculator.required': 'Povinné',
  
  // Step Calculation
  'calculator.price_calculation': 'Cenová kalkulácia',
  'calculator.translation_no_vat': 'Preklad (bez DPH)',
  'calculator.notary_copies_no_vat': 'Overené kópie (bez DPH)',
  'calculator.delivery_no_vat': 'Doručenie (bez DPH)',
  'calculator.total_no_vat': 'Spolu bez DPH',
  'calculator.sum_no_vat': 'Suma bez DPH',
  'calculator.vat': 'DPH (23%)',
  'calculator.final_total': 'Konečná suma s DPH',
  'calculator.total_with_vat': 'Celkom s DPH',
  'calculator.back': 'Späť',
  'calculator.fill_details': 'Doplniť údaje',
  
  // Step Order
  'calculator.order_completion': 'Dokončenie objednávky',
  'calculator.binding_method': 'Spôsob viazania prekladu',
  'calculator.binding_original': 'Doručím originál',
  'calculator.binding_original_desc': 'Poštou alebo osobne počas pracovných dní 9:00 - 15:00 na adresu: Legalizačné centrum Bratislava, Pluhová 17, 831 03 Bratislava.',
  'calculator.binding_notary': 'Mám záujem o zabezpečenie overenej kópie u vás',
  'calculator.binding_notary_desc': 'Vybavíme overenú kópiu u notára za vás (+8€ bez DPH / str.)',
  'calculator.binding_scan': 'Viazanie so skenom',
  'calculator.binding_scan_desc': 'Preklad zviažeme s vytlačeným skenom. Nemusíte nič doručovať.',
  'calculator.delivery_method': 'Spôsob doručenia hotového prekladu',
  'calculator.delivery_address': 'Doručovacia adresa',
  'calculator.courier_contact': 'Kontakt pre kuriéra',
  'calculator.street_number': 'Ulica a číslo',
  'calculator.city': 'Mesto',
  'calculator.postal_code': 'PSČ',
  'calculator.country': 'Krajina',
  'calculator.contact_name': 'Meno kontaktnej osoby',
  'calculator.contact_phone': 'Telefónne číslo',
  'calculator.dhl_abroad_note': 'Cenu DHL do zahraničia vám nacenime individuálne po odoslaní objednávky.',
  'calculator.total_price': 'Celková cena',
  'calculator.contact_info': 'Kontaktné údaje',
  'calculator.full_name': 'Celé meno',
  'calculator.company_name': 'Názov firmy',
  'calculator.ico': 'IČO',
  'calculator.dic': 'DIČ',
  'calculator.email': 'E-mail',
  'calculator.phone': 'Telefón',
  'calculator.billing_differs': 'Fakturačná adresa je odlišná od doručovacej',
  'calculator.billing_address': 'Fakturačná adresa - Ulica a číslo',
  'calculator.order_note': 'Poznámka k objednávke',
  'calculator.order_note_optional': 'voliteľné',
  'calculator.order_note_placeholder': 'Akékoľvek špeciálne požiadavky alebo poznámky k prekladu...',
  'calculator.toggle_business': 'Fakturovať na firmu',
  'calculator.toggle_private': 'Meniť na súkromnú osobu',
  'calculator.submit_order': 'Odoslať objednávku',
  'calculator.submitting': 'Odosiela sa...',
  'calculator.individual_pricing': 'Individuálne',
  'calculator.free': 'Zdarma',
  
  // Success View
  'calculator.success_title': 'Hotovo! Objednávka bola prijatá',
  'calculator.order_number': 'Číslo objednávky',
  'calculator.no_original_needed': 'Nemusíte nám doručovať originál.',
  'calculator.scan_binding_info': 'Zvolili ste viazanie so skenom. Dokument spracujeme na základe vami nahraného súboru. Po zaplatení faktúry vám hotový preklad doručíme.',
  'calculator.deliver_to_address': 'Doručte nám podklady na adresu:',
  'calculator.office_name': 'Legalizačné centrum',
  'calculator.office_address': 'Pluhová 17, 831 03 Bratislava',
  'calculator.office_hours': 'Po - Pia: 9:00 - 15:00',
  'calculator.mail_recommendation': 'Ak posielate originál poštou, odporúčame Doporučený list alebo kuriéra pre bezpečné doručenie.',
  'calculator.print_quote': 'Tlačiť cenovú ponuku',
  'calculator.new_order': 'Nová objednávka',
  
  // Messages
  'calculator.order_success': 'Objednávka bola úspešne odoslaná!',
  'calculator.order_error': 'Nepodarilo sa odoslať objednávku. Skúste to prosím znova.',

  // Pricing extras
  'pricing.per_page': 'strana',

  // Language names for calculator
  'languages.sk': 'Slovenčina',
  'languages.en': 'Angličtina',
  'languages.de': 'Nemčina',
  'languages.hu': 'Maďarčina',
  'languages.pl': 'Poľština',
  'languages.uk': 'Ukrajinčina',
  'languages.ru': 'Ruština',
  'languages.fr': 'Francúzština',
  'languages.es': 'Španielčina',
  'languages.it': 'Taliančina',
  'languages.pt': 'Portugalčina',
  'languages.tr': 'Turečtina',
  'languages.sr': 'Srbčina',
  'languages.hr': 'Chorvátčina',
  'languages.bg': 'Bulharčina',
  'languages.el': 'Gréčtina',
  'languages.ro': 'Rumunčina',
  'languages.ar': 'Arabčina',
  'languages.mk': 'Macedónčina',
  'languages.no': 'Nórčina',
  'languages.nl': 'Holandčina',
  'languages.sl': 'Slovinčina',
  'languages.zh': 'Čínština',
  'languages.lt': 'Litovčina',
  'languages.md': 'Moldavčina',
  'languages.other': 'Iný jazyk – nacenenie',
  
  // Calculator - NS abbreviation
  'calculator.standard_pages_short': 'NS',
  
  // Company autocomplete
  'calculator.company_search_placeholder': 'Začnite písať názov firmy alebo IČO...',
  'calculator.company_source': 'Zdroj: slovensko.digital',

  // Cookie consent
  'cookies.message': 'Táto stránka používa cookies na zlepšenie vášho zážitku a analýzu návštevnosti.',
  'cookies.privacy_link': 'Viac o ochrane osobných údajov →',
  'cookies.settings': 'Nastavenia',
  'cookies.decline': 'Len nevyhnutné',
  'cookies.accept_all': 'Prijať všetky',
  'cookies.save_preferences': 'Uložiť nastavenia',
  'cookies.necessary_title': 'Nevyhnutné cookies',
  'cookies.necessary_desc': 'Potrebné pre základné fungovanie stránky. Nedajú sa vypnúť.',
  'cookies.analytics_title': 'Analytické cookies',
  'cookies.analytics_desc': 'Pomáhajú nám pochopiť, ako návštevníci používajú stránku.',
  'cookies.functional_title': 'Funkčné cookies',
  'cookies.functional_desc': 'Umožňujú rozšírené funkcie ako zapamätanie preferencií.',
  'cookies.marketing_title': 'Marketingové cookies',
  'cookies.marketing_desc': 'Používané na zobrazovanie relevantnej reklamy.',

  // Privacy page
  'privacy.meta_title': 'Ochrana osobných údajov | Prelozim.sk',
  'privacy.meta_desc': 'Zásady ochrany osobných údajov a cookies. GDPR, bezpečnosť dokumentov, šifrovanie prenosu, automatické mazanie.',
  'privacy.badge': 'Právne informácie',
  'privacy.title': 'Ochrana osobných údajov',
  'privacy.subtitle': 'Vaše súkromie je pre nás prioritou. Tu nájdete podrobné informácie o tom, ako chránime vaše osobné údaje a dokumenty.',
  'privacy.last_updated': 'Posledná aktualizácia',
  'privacy.section1_title': 'Zabezpečenie prenosu dát',
  'privacy.section1_content': 'Všetky dokumenty a osobné údaje sú prenášané prostredníctvom šifrovaného spojenia využívajúceho protokol TLS 1.3. Tento štandard zabezpečuje, že vaše dáta nemôžu byť počas prenosu zachytené alebo prečítané tretími stranami.',
  'privacy.section2_title': 'Ukladanie dokumentov',
  'privacy.section2_content': 'Vaše dokumenty sú uložené na zabezpečených serveroch s prísnym kontrolovaným prístupom. Prístup k dokumentom majú výlučne priradení súdni prekladatelia a v prípade potreby náš zákaznícky servis. Všetky servery sa nachádzajú v rámci Európskej únie a podliehajú európskej legislatíve o ochrane osobných údajov.',
  'privacy.section3_title': 'Spracovanie osobných údajov',
  'privacy.section3_content': 'Spracovávame len údaje nevyhnutné pre poskytnutie služby: meno, kontaktné údaje a dokumenty na preklad. Tieto údaje používame výlučne na vybavenie vašej objednávky a komunikáciu s vami. Vaše údaje nikdy nepredávame tretím stranám na marketingové alebo iné účely.',
  'privacy.section4_title': 'Uchovávanie a mazanie dát',
  'privacy.section4_content': 'Dokumenty sú uchovávané maximálne 30 dní od dokončenia zákazky pre prípad reklamácie alebo doplňujúcich otázok. Po uplynutí tejto doby sú automaticky a nezvratne vymazané z našich serverov. Na vašu žiadosť môžeme dokumenty vymazať kedykoľvek počas tejto doby.',
  'privacy.section5_title': 'Vaše práva',
  'privacy.section5_content': 'Podľa GDPR máte právo na prístup k svojim osobným údajom, ich opravu, vymazanie (právo byť zabudnutý), obmedzenie spracovania, prenositeľnosť údajov a právo vzniesť námietku proti spracovaniu. Pre uplatnenie týchto práv nás kontaktujte na office@legalizacnecentrum.sk.',
  'privacy.section6_title': 'Kontakt na zodpovednú osobu',
  'privacy.section6_content': 'V prípade akýchkoľvek otázok týkajúcich sa ochrany osobných údajov nás môžete kontaktovať na: office@legalizacnecentrum.sk alebo telefonicky na 0907 999 909 (mobil) a 02/ 4333 3509 (pevná linka). Prevádzkovateľ: Legalizačné centrum Bratislava s.r.o., Pluhová 17, 831 03 Bratislava. Na vaše otázky a žiadosti odpovieme do 30 dní.',
  'privacy.cookies_title': 'Súbory cookies',
  'privacy.cookies_intro': 'Naša webová stránka používa cookies na zabezpečenie správneho fungovania, analýzu návštevnosti a zlepšenie vášho zážitku.',
  'privacy.what_are_cookies_title': 'Čo sú cookies?',
  'privacy.what_are_cookies_text': 'Cookies sú malé textové súbory, ktoré webové stránky ukladajú do vášho zariadenia (počítač, tablet, mobilný telefón). Pomáhajú stránke zapamätať si informácie o vašej návšteve, ako napríklad preferovaný jazyk a iné nastavenia.',
  'privacy.cookie_types_title': 'Typy cookies, ktoré používame',
  'privacy.cookie_necessary_name': 'Nevyhnutné cookies',
  'privacy.cookie_necessary_desc': 'Tieto cookies sú nevyhnutné pre správne fungovanie webovej stránky. Zahŕňajú napríklad cookies, ktoré vám umožňujú prihlásiť sa do zabezpečených oblastí alebo používať nákupný košík.',
  'privacy.cookie_necessary_examples': 'Príklady: session ID, CSRF token, jazykové preferencie',
  'privacy.cookie_analytics_name': 'Analytické cookies',
  'privacy.cookie_analytics_desc': 'Tieto cookies nám umožňujú počítať návštevy a zdroje návštevnosti, aby sme mohli merať a zlepšovať výkon našej stránky. Pomáhajú nám zistiť, ktoré stránky sú najobľúbenejšie a ako sa návštevníci pohybujú po stránke.',
  'privacy.cookie_analytics_examples': 'Príklady: Google Analytics, Hotjar',
  'privacy.cookie_functional_name': 'Funkčné cookies',
  'privacy.cookie_functional_desc': 'Tieto cookies umožňujú webovej stránke poskytovať rozšírené funkcie a personalizáciu. Môžu byť nastavené nami alebo poskytovateľmi tretích strán, ktorých služby sme pridali na naše stránky.',
  'privacy.cookie_functional_examples': 'Príklady: live chat, video prehrávače, zdieľanie na sociálnych sieťach',
  'privacy.cookie_marketing_name': 'Marketingové cookies',
  'privacy.cookie_marketing_desc': 'Tieto cookies môžu byť nastavené prostredníctvom našej stránky našimi reklamnými partnermi. Môžu byť nimi použité na vytvorenie profilu vašich záujmov a zobrazenie relevantných reklám na iných stránkach.',
  'privacy.cookie_marketing_examples': 'Príklady: Facebook Pixel, Google Ads, LinkedIn Insight',
  'privacy.cookie_required': 'Vždy aktívne',
  'privacy.cookie_optional': 'Voliteľné',
  'privacy.managing_cookies_title': 'Ako spravovať cookies',
  'privacy.managing_cookies_text': 'Môžete kedykoľvek zmeniť svoje preferencie cookies pomocou tlačidla nižšie alebo v nastaveniach vášho prehliadača. Väčšina prehliadačov vám umožňuje odmietnuť cookies alebo ich vymazať.',
  'privacy.change_cookie_settings': 'Zmeniť nastavenia cookies',
  'privacy.third_party_title': 'Cookies tretích strán',
  'privacy.third_party_text': 'Niektoré cookies môžu byť nastavené tretími stranami, ktorých služby používame na našej stránke. Nemáme priamy prístup k týmto cookies. Pre viac informácií o tom, ako tieto tretie strany používajú cookies, si pozrite ich vlastné zásady ochrany súkromia.',
  'privacy.commitment_title': 'Náš záväzok',
  'privacy.commitment_text': 'Zaväzujeme sa dodržiavať všetky ustanovenia Nariadenia Európskeho parlamentu a Rady (EÚ) 2016/679 (GDPR) a súvisiacej slovenskej legislatívy. Neustále pracujeme na zlepšovaní našich bezpečnostných opatrení, aby vaše údaje boli v maximálnom bezpečí.',

  // Calculator / Service Selector
  'calculator.title': 'Kalkulátor úradných prekladov',
  'calculator.subtitle': 'Čo potrebujete?',
  'calculator.service_translation_title': 'Úradný preklad',
  'calculator.service_translation_desc': 'Vypočítam cenu a môžete objednať online',
  'calculator.service_translation_legalization_title': 'Preklad + Legalizácia',
  'calculator.service_translation_legalization_subtitle': '(apostila / superlegalizácia)',
  'calculator.service_translation_legalization_desc': 'Cenu pripravíme na mieru do niekoľkých hodín',
  'calculator.service_legalization_title': 'Len legalizácia',
  'calculator.service_legalization_subtitle': '(apostila / superlegalizácia)',
  'calculator.service_legalization_desc': 'Cenu pripravíme na mieru do niekoľkých hodín',
  'calculator.service_unknown_title': 'Neviem / Potrebujem poradiť',
  'calculator.service_unknown_desc': 'Kontaktujte nás a poradíme vám',
  'calculator.badge_calculator': 'Kalkulátor',
  'calculator.badge_quote': 'Cenová ponuka',
  'calculator.badge_contact': 'Kontakt',
  
  // Apostila Page - additional
  'apostila.jsonld_name': 'Apostila dokumentov',
  'apostila.jsonld_description': 'Profesionálne vybavenie apostily pre všetky typy dokumentov. Rýchle vybavenie, transparentné ceny, doručenie do celého sveta.',
  'apostila.service_type': 'Apostila dokumentov',
  'apostila.hero_badge': '11 rokov skúseností',
  'apostila.hero_title': 'Apostila dokumentov',
  'apostila.hero_subtitle': 'vydaných v SR',
  'apostila.hero_description': 'Potrebujete dokument s apostilou pre použitie v zahraničí? Zabezpečíme kompletný servis vrátane úradného prekladu. Vybavíme rýchlo a profesionálne.',
  'apostila.hero_time': 'Vybavenie už od 1 dňa',
  'apostila.hero_price': 'Od 120 € väčšina dokumentov',
  'apostila.hero_cta': 'Nezáväzná ponuka do pár hodín',
  'apostila.badge_years': 'Rokov skúseností',
  'apostila.badge_reviews': 'Google referencií',
  'apostila.badge_complaints': 'Reklamácií',
  'apostila.badge_documents': 'Vybavených dokumentov',
  'apostila.step1_title': 'Zašlite nám dokument',
  'apostila.step1_desc': 'Pošlite nám sken dokumentu emailom alebo cez formulár. Môžete nám ho tiež priniesť osobne.',
  'apostila.step2_title': 'Preveríme požiadavky',
  'apostila.step2_desc': 'Skontrolujeme dokument a potvrdíme, či je možné apostilu vybaviť. Informujeme vás o cene a termíne.',
  'apostila.step3_title': 'Vybavíme apostilu',
  'apostila.step3_desc': 'Zabezpečíme apostilu na príslušnom úrade. V prípade potreby zabezpečíme aj úradný preklad.',
  'apostila.step4_title': 'Doručíme vám dokumenty',
  'apostila.step4_desc': 'Hotové dokumenty si môžete vyzdvihnúť osobne alebo vám ich zašleme kuriérom kamkoľvek na svete.',
  'apostila.process_badge': 'Ako to funguje',
  'apostila.process_title': '4 jednoduché kroky',
  'apostila.process_subtitle': 'Celý proces apostilácie je jednoduchý. Všetko vybavíme za vás.',
  'apostila.faq_badge': 'Časté otázky',
  'apostila.faq_subtitle': 'Odpovede na najčastejšie otázky o apostile.',
  'apostila.faq1_q': 'Čo je apostila?',
  'apostila.faq1_a': 'Apostila je medzinárodné overenie pravosti dokumentu, ktoré nahrádza zdĺhavý proces diplomatického overenia. Platí vo všetkých krajinách, ktoré podpísali Haagsky dohovor z roku 1961.',
  'apostila.faq2_q': 'Na aké dokumenty môžem získať apostilu?',
  'apostila.faq2_a': 'Apostilu je možné získať na väčšinu verejných listín – rodné listy, sobášne listy, úmrtné listy, diplomy, vysvedčenia, výpisy z registra trestov, výpisy z obchodného registra, notárske dokumenty a ďalšie.',
  'apostila.faq3_q': 'Ako dlho trvá vybavenie apostily?',
  'apostila.faq3_a': 'Štandardná doba vybavenia je 1-5 pracovných dní v závislosti od typu dokumentu. Expresné vybavenie do 24 hodín je možné po dohode.',
  'apostila.faq4_q': 'Potrebujem k apostile aj preklad?',
  'apostila.faq4_a': 'Väčšina krajín vyžaduje okrem apostily aj úradný preklad dokumentu do jazyka cieľovej krajiny. Zabezpečíme kompletný servis vrátane prekladu.',
  'apostila.faq5_q': 'Musím priniesť originál dokumentu?',
  'apostila.faq5_a': 'Vo väčšine prípadov áno, originál dokumentu je potrebný. V niektorých prípadoch ako výpis z obchodného registra a pod. si vieme údaje stiahnuť priamo z registra.',
  'apostila.faq6_q': 'Aký je rozdiel medzi apostilou a superlegalizáciou?',
  'apostila.faq6_a': 'Apostila platí v krajinách Haagskej dohody (125+ krajín). Pre krajiny mimo tejto dohody (napr. Spojené arabské emiráty, Malajzia, väčšina afrických krajín) je potrebná superlegalizácia, ktorá zahŕňa viacero krokov vrátane overenia na ministerstve a veľvyslanectve.',
  'apostila.faq7_q': 'Koľko stojí apostila?',
  'apostila.faq7_a': 'Ceny apostily začínajú od 120 € v závislosti od typu dokumentu. Kontaktujte nás pre presnú cenovú ponuku.',
  'apostila.faq8_q': 'Môžete zabezpečiť apostilu zahraničných dokumentov?',
  'apostila.faq8_a': 'Áno, pomáhame zabezpečiť apostilu zahraničných dokumentov priamo v krajine ich vydania.',
  'apostila.cta_title': 'Potrebujete pomôcť s apostilou?',
  'apostila.cta_subtitle': 'Kontaktujte nás a my sa o všetko postaráme. Bezplatná konzultácia.',
  'apostila.cta_form_button': 'Napíšte cez kontaktný formulár',
  'apostila.cta_footer': 'Bezplatná konzultácia • Odpovieme do pár hodín • Transparentné ceny',
  'apostila.country_list_title': 'Pre ktoré krajiny potrebujem apostilu?',
  'apostila.country_list_note': 'Ak vaša cieľová krajina nie je členom Haagskej dohody, budete potrebovať superlegalizáciu.',
  'apostila.country_list_cta': 'Zistiť viac o superlegalizácii',
  
  // Superlegalizacia Page - additional
  'superlegalizacia.step1_title': 'Pošlite nám sken',
  'superlegalizacia.step1_desc': 'Bezplatná konzultácia - posúdime aké sú možnosti, cenu a termín vybavenia pre váš dokument.',
  'superlegalizacia.step2_title': 'Overenie na všetkých orgánoch',
  'superlegalizacia.step2_desc': 'Zabezpečíme overenie na všetkých dotknutých orgánoch podľa správneho postupu pre daný typ dokumentu vrátane úradných prekladov.',
  'superlegalizacia.step3_title': 'Konzulárne overenie',
  'superlegalizacia.step3_desc': 'Finálne overenie na veľvyslanectve alebo konzuláte cieľovej krajiny v Bratislave, Viedni, Berlíne či v inej krajine podľa príslušnosti.',
  'superlegalizacia.step4_title': 'Doručenie do celého sveta',
  'superlegalizacia.step4_desc': 'Hotové dokumenty vám doručíme na Slovensku poštou alebo kamkoľvek na svete cez DHL.',
  'superlegalizacia.process_title': 'Proces superlegalizácie',
  'superlegalizacia.process_subtitle': 'Superlegalizácia je zložitejší proces, ktorý vyžaduje viacero krokov. My sa postaráme o všetko.',
  'superlegalizacia.faq_subtitle': 'Odpovede na najčastejšie otázky o superlegalizácii.',
  'superlegalizacia.faq1_q': 'Čo je superlegalizácia?',
  'superlegalizacia.faq1_a': 'Superlegalizácia je overenie dokumentov pre krajiny, ktoré nepodpísali Haagsky dohovor. Zahŕňa viacero krokov: notárske overenie, apostilu, overenie na Ministerstve zahraničných vecí a konzulárne overenie.',
  'superlegalizacia.faq2_q': 'Pre ktoré krajiny potrebujem superlegalizáciu?',
  'superlegalizacia.faq2_a': 'Superlegalizácia je potrebná pre krajiny ako Spojené arabské emiráty, Katar, Omán, Kuvajt, väčšina afrických krajín, niektoré ázijské krajiny a ďalšie, ktoré nie sú súčasťou Haagskej dohody.',
  'superlegalizacia.faq3_q': 'Ako dlho trvá superlegalizácia?',
  'superlegalizacia.faq3_a': 'Superlegalizácia je zložitejší proces, ktorý trvá väčšinou 4 týždne. V niektorých prípadoch môže trvať aj dlhšie v závislosti od cieľovej krajiny a aktuálnych lehôt na veľvyslanectvách.',
  'superlegalizacia.faq4_q': 'Koľko stojí superlegalizácia?',
  'superlegalizacia.faq4_a': 'Ceny superlegalizácie začínajú od 490 € a závisia od typu dokumentu a cieľovej krajiny. Kontaktujte nás pre presnú cenovú ponuku.',

  // Expertise Section
  'expertise.badge': 'Prečo práve my',
  'expertise.title': 'Legalizačné centrum',
  'expertise.subtitle': 'Spolu s advokátskou kanceláriou AKMV prinášame profesionalitu a spokojnosť množstva klientov.',
  'expertise.leader.title': 'Líder na trhu od roku 2013',
  'expertise.leader.description': '11 rokov skúseností a celkový dohľad kolegov advokátov. Expertíza v každom kroku.',
  'expertise.security.title': 'Bezpečnosť dokumentov',
  'expertise.security.description': 'Legalizácia v sídle advokátskej kancelárie s vyššou úrovňou ochrany a mlčanlivosti.',
  'expertise.zero_complaints.title': '0 reklamácií za 11 rokov',
  'expertise.zero_complaints.description': 'Vopred vás informujeme o presnej cene a termíne vybavenia. Žiadne nepríjemné prekvapenia.',
  'expertise.realistic.title': 'Realistické termíny, žiadne prázdne sľuby',
  'expertise.realistic.description': 'Vieme presne, koľko ktorý úkon trvá. Nesľubujeme nereálne termíny - dodržíme, čo dohodneme.',
  'expertise.support.title': 'Podpora aj po vybavení',
  'expertise.support.description': 'Pri otázkach zahraničných úradov k vašim dokumentom poskytneme následný support. Komunikujeme v angličtine. Odporúčajú nás slovenské matriky a úrady.',
  'expertise.express.title': 'Expresná rýchlosť bez príplatkov',
  'expertise.express.description': 'Všetko riešime expresne ako štandard. Žiadne dodatočné poplatky za rýchle vybavenie.',
  'expertise.embassies.title': 'Priame kontakty na ambasády',
  'expertise.embassies.description': 'Máme naviazané vzťahy s veľvyslanectvami. Presne vieme, ako ktorá ambasáda funguje a čo vyžaduje.',
  'expertise.fix.title': 'Vyriešime aj komplikácie',
  'expertise.fix.description': 'Nesediaci podpisový vzor? Chýbajúce náležitosti? Opravíme a upravíme dokumenty do súladu s požiadavkami konkrétnej krajiny. Máme skúsenosti s desiatkami destinácií.',
};

export type TranslationKey = keyof typeof baseTranslations;
